import { Component, OnInit } from '@angular/core';
import { IFormulario } from 'src/app/models/Formulario';
import { IGenericResponse } from 'src/app/models/IGenericResponse';
import { LRV } from 'src/app/models/Lead-reseller-vf';
import { LeadResellerVodafoneService } from 'src/app/service/lead-reseller-vodafone.service';
import { Router, ActivatedRoute  } from '@angular/router';
import { NotificationService } from 'src/app/service/notificaciones.service';
@Component({
  selector: 'app-lead-reseller-vf',
  templateUrl: './lead-reseller-vf.component.html',
  styleUrls: ['./lead-reseller-vf.component.css']
})
export class LeadResellerVfComponent implements OnInit{

  formulario: IFormulario[] = [];
  formulario_codigo_sms: IFormulario[] = [];

  url_imagenes: string[] = [
    "assets/lowi_png.png",
    "assets/vodafone.png",
    "assets/LogoSecuritas.png"
  ]
  url_imagen_bottom: string[] = [
    "assets/Imagen1.png"
  ];

  ver_dialog_sms: boolean = false;
  ver_dialog_distribuidor_no_encontrado: boolean = false;

  distribuidor: string = "";
  codigo_sms: string = '';
  datos_LRV: LRV = {
    id: 0,
    nombre: '',
    apellidos: '',
    dni: '',
    email: '',
    calle_numero: '',
    cp: '',
    poblacion: '',
    provincia: '',
    telefono: '',
    telefono_2: '',
    comentarios: '',
    residencial_negocio: '',
    producto: [],
    politica: false,
    datos_personales: false
  }
  intentos_sms: number = 0;
  bloquear_envio: boolean = false;

  constructor(private LeadResellerVodafoneService: LeadResellerVodafoneService, private Router: Router, private activatedRoute: ActivatedRoute, private notificacionesService: NotificationService) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.distribuidor = params['distribuidor'];
    });    
    console.log('distribuidor', this.distribuidor);
    this.inicializarFormulario();
    if(this.distribuidor != null){
      console.log('distribuidor', this.distribuidor);
      this.LeadResellerVodafoneService.validarDistribuidor(this.distribuidor).subscribe((response: IGenericResponse) => {
        console.log('respuesta distribuidor', response);
        //OPCION 1
        // if(response.error == "Distribuidor no encontrado."){
        //   this.notificacionesService.notificacionError(response.error);
        // }
        //OPCION 2
        if(response.error) {
          this.ver_dialog_distribuidor_no_encontrado = true;
        }
      })
    } else{
      this.ver_dialog_distribuidor_no_encontrado = true;
    }
  }

  inicializarFormulario() {
    this.formulario = [
      { fields: ['solicitud_estudio'], headers: ['Solicitud de estudio'], type: ['cabecera'], options: [], parametros: [{strong: false, justify_content: 'center', color: 'red', font_size: '18px'}], validador: [false] },
      { fields: ['td'], headers: [this.distribuidor], type: ['cabecera'], options: [], parametros: [{strong: true, justify_content: 'center', color: 'red', font_size: '18px', margin_bottom: "3%"}], validador: [false] },
      { fields: ['datos_cliente'], headers:['Datos del cliente'], type: ['cabecera'], options: [], parametros: [{strong: false, justify_content: 'start', color: 'red', font_size: '18px', margin_bottom: "3%"}], validador: [false] },
      { 
        fields: ['nombre', 'apellidos'], 
        headers: ['Nombre', 'Apellidos'], 
        type: ['text', 'text'], 
        options: [], 
        parametros: [
          { tipo: 'string', icon: 'pi pi-user', pos_icon: 'right', icon_color: 'red' },
          { tipo: 'string', icon: 'pi pi-user', pos_icon: 'right', icon_color: 'red' }
        ], 
        validador: [true, true] 
      },
      { 
        fields: ['dni', 'email'], 
        headers: ['DNI', 'Email'], 
        type: ['dni', 'correo'], 
        options: [], 
        parametros: [
          { tipo: 'string', icon_color: 'red' },
          { tipo: 'correo', icon: 'pi pi-envelope', pos_icon: 'right', icon_color: 'red' }
        ], 
        validador: [true, true] 
      },
      { 
        fields: ['calle_numero', 'cp'], 
        headers: ['Calle y número', 'CP'], 
        type: ['text', 'codigo_postal'], 
        options: [], 
        parametros: [
          { tipo: 'string', icon: 'pi pi-search', pos_icon: 'right', icon_color: 'red' }, 
          { }
        ], 
        validador: [true, true] 
      },
      { 
        fields: ['poblacion', 'provincia'], 
        headers: ['Población', 'Provincia'], 
        type: ['text', 'text'], 
        options: [], 
        parametros: [{}, {}], 
        validador: [true, true] 
      },
      { 
        fields: ['telefono', 'segundo_telefono'], 
        headers: ['Teléfono', 'Telf Fijo / 2º Teléfono'], 
        type: ['telefono', 'telefono'], 
        options: [], 
        parametros: [
          { tipo: 'telefono', icon: 'pi pi-phone', pos_icon: 'right', icon_color: 'red' }, 
          { tipo: 'telefono', icon: 'pi pi-phone', pos_icon: 'right', icon_color: 'red' }
        ], 
        validador: [true, true] 
      },
      { fields: ['comentarios'], headers: ['Comentarios'], type: ['text'], options: [], parametros: [{}], validador: [true] },
      { fields: ['producto'], headers: ['Producto'], type: ['cabecera'], options: [], parametros: [{strong: false, justify_content: 'start', color: 'red', font_size: '18px', margin_bottom: "3%", margin_top: "3%"}], validador: [false] },
      { fields: ['residencial_negocio'], headers: ['Residencial o Negocio'], type:[ 'text'], options: [], parametros: [{tipo: 'string'}], validador: [true] },
      { fields: ['productos'], headers: ['Seleccione uno o varios productos:'], type: ['pick'], options: ['VODAFONE', 'LOWI', 'SECURITAS DIRECT'], parametros: [{posicion_pick: 'right', tipo: '', numero_seleccionables: 3, strong: true, font_size: '13px',margin_top: "3%", margin_bottom: "3%", font_size_opciones: '15px'}], validador: [true] },
      { fields: ['privacidad'], headers: ['Privacidad'], type: ['aceptar-check'], options: [], parametros: [{ tipo: 'aceptar-check', texto: `He leído y acepto la <a href="https://topdigital.com/info/7-politica-de-privacidad" target="_blank">política de privacidad</a>.`}], validador: [true] },
      { fields: ['datos_personales'], headers: ['Datos Personales'], type: ['aceptar-check'], options: [], parametros: [{ tipo: 'boolean', texto: `Acepto que mis datos personales sean cedidos por Top Digital a alas entidades que prestan servicios a la misma.`}], validador: [false] },
      { fields: ['enviar'], headers: ['Enviar'], type: ['boton-enviar'], options: [], parametros: [{ color: 'red' }], validador: [false] },
    ];
    this.formulario_codigo_sms = [
      { fields: ['cabecera'], headers: ['Introduzca el codigo SMS a continuación:'], type: ['cabecera'], options: [], parametros: [{strong: false, justify_content: 'center', color: 'red', font_size: '18px'}], validador: [false] },
      { fields: ['codigo'], headers: ['Código SMS'], type:[ 'text'], options: [], parametros: [{}], validador: [false] },
      { fields: ['enviar'], headers: ['Enviar'], type: ['boton-enviar'], options: [], parametros: [{ color: 'red' }], validador: [false] },
    ];
  }
  onRecibirFormulario(formulario: any) {
    this.datos_LRV = {
      id: 0,
      nombre: formulario['nombre'],
      apellidos: formulario['apellidos'],
      dni: formulario['dni'],
      email: formulario['email'],
      calle_numero: formulario['calle_numero'],
      cp: formulario['cp'],
      poblacion: formulario['poblacion'],
      provincia: formulario['provincia'],
      telefono: formulario['telefono'],
      telefono_2: formulario['segundo_telefono'],
      comentarios: formulario['comentarios'],
      residencial_negocio: formulario['residencial_negocio'],
      producto: formulario['productos'],
      politica: formulario['politica'] ? true : false,
      datos_personales: formulario['datos_personales'] ? true : false,
      nombre_distribuidor: this.distribuidor
    }    
    this.LeadResellerVodafoneService.enviarSMS(this.datos_LRV.telefono).subscribe((response: IGenericResponse) => {
      this.ver_dialog_sms = true;
      this.codigo_sms = response.data.code;
    })
  }
  onRecibirFormularioSMS(codigo: any){
    if(codigo['codigo'] == this.codigo_sms){
      this.LeadResellerVodafoneService.nuevoUsuarioLRV(this.datos_LRV).subscribe((response: IGenericResponse) => {
        if(response.error){
          this.notificacionesService.notificacionError(response.error);
        } else{
          this.ver_dialog_sms = false;
          this.bloquear_envio = false;
          this.inicializarFormulario();
          this.notificacionesService.notificacionSuccess(response.message);
        }
      })
    } else if(codigo['codigo'] != this.codigo_sms && this.intentos_sms == 3){

    } else{
      this.intentos_sms++;
      this.notificacionesService.notificacionError("El codigo introducido es incorrecto.");
    }
  }
}
